import { styled } from "styled-components";
const TensorGridItemCell = styled("div")(
  ({ theme }) => ({
    borderColor: theme.borderColor,
    borderStyle: "solid",
    borderWidth: `0 1px 1px 0`,
    position: "relative"
  }),
  ({ rowSpan }) => ({
    gridRowEnd: `span ${rowSpan}`
  }),
  ({ $lastColumn }) => $lastColumn ? {
    borderRightWidth: 0
  } : void 0,
  ({ $lastRow }) => $lastRow ? {
    borderBottomWidth: 0
  } : void 0
);
const TensorGridItemLabel = styled("div")(
  {
    backgroundColor: "#fafafa",
    boxSizing: "border-box",
    height: "100%",
    padding: "5px 12px"
  },
  ({ $align }) => ({ textAlign: $align }),
  ({ $firstColumn }) => $firstColumn ? {
    paddingLeft: 16
  } : void 0
);
export {
  TensorGridItemCell,
  TensorGridItemLabel
};
